import { t } from 'i18next';
import { DirectorProfile } from '../pages/DashboardDirector/DirectorProfile';
import { DirectorHome } from '../pages/DashboardDirector/DirectorHome';
import { DirectorDocuments } from '../pages/DashboardDirector/DirectorDocuments';
import { PreferencesScreen } from '../pages/DashboardCustomer/Preferences';

const directorRoutes = [
  {
    path: '',
    name: t('others.othDashboard'),
    component: <DirectorHome />
  },
  {
    path: 'profile',
    name: t('labels.lblMyProfile') || 'Profile',
    component: <DirectorProfile />
  },
  {
    path: 'documents',
    name: t('labels.lblMyDocuments') || 'Documents',
    component: <DirectorDocuments />
  },
  {
    path: 'preferences',
    name: t('labels.lblPrefereces') || 'Preferences',
    component: <PreferencesScreen />
  }
];

export { directorRoutes };
